module.exports = __webpack_public_path__ + "img/zj_summary_Image.aa02a4d3.png";